
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { CheckCircle } from 'lucide-react';

const SourceMapsCard: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CheckCircle className="h-5 w-5 text-green-500" />
          Source Maps Configuration
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Alert>
          <CheckCircle className="h-4 w-4" />
          <AlertDescription>
            Source maps are fully configured and will be automatically uploaded during production builds.
          </AlertDescription>
        </Alert>

        <div className="bg-white border border-green-200 rounded-lg p-4">
          <h4 className="font-medium text-green-800 mb-2">✓ Configuration Complete:</h4>
          <ul className="text-sm text-green-700 space-y-2">
            <li>• Organization: <code className="bg-white px-1 rounded">wisefools</code></li>
            <li>• Project: <code className="bg-white px-1 rounded">javascript-react</code></li>
            <li>• Auth token: <code className="bg-white px-1 rounded">Configured in vite.config.ts</code></li>
            <li>• Upload target: <code className="bg-white px-1 rounded">./dist/**</code></li>
          </ul>
        </div>

        <div className="bg-white border border-blue-200 rounded-lg p-4">
          <h4 className="font-medium text-black mb-2">How It Works:</h4>
          <ol className="text-sm text-black space-y-1 list-decimal list-inside">
            <li>Source maps are generated during production builds</li>
            <li>Maps are automatically uploaded to Sentry after build completion</li>
            <li>Source map files are cleaned up after successful upload</li>
            <li>Production errors will show original source code locations</li>
          </ol>
        </div>

        <div className="bg-white border border-green-200 rounded-lg p-4">
          <h4 className="font-medium text-green-800 mb-2">Benefits:</h4>
          <ul className="text-sm text-green-700 space-y-1">
            <li>• Readable stack traces in production errors</li>
            <li>• Original source code locations in error reports</li>
            <li>• Better debugging experience for production issues</li>
            <li>• Improved error context and resolution</li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};

export default SourceMapsCard;
